/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';

const styles = cssMap({
	dialogInner: {
		minWidth: '220px',
		overflow: 'hidden',
	},
});

export const DialogInner = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.dialogInner} {...props}>
		{children}
	</div>
);
